// ----------------- Documentation ---------------------------
// this component used for add and edit the data from specification template list
// this form used the firebase database to store the data

// props                   type                usedfor
// -------                 -------             --------
// title                   string              to maintain title of the popup
// open                    boolean             to check the action for open and close the popup
// onClose                 boolean             to close the popup
// edit                    boolead             used for the edit form
// edittitle               string              to maintain the edit form title of the popup
// data                    array               to show the default form value in the edit form

import React, { useContext, useState } from "react";
import FormModal from "../../../../shared-component/formmodal-component/FormModal";
import Form from "../../../../shared-component/formrelated-component/FormManager";

import { useSnackbar } from "notistack";
import UserContext from "../../../../../context/UserContext";
import { apiService } from "../../../../../constant/AuthConstant";
import returnError from "../../../../../utils/ExportError";
import useExit from "../../../../../utils/useExit";

function AddTemplate({
    title,
    open,
    onClose,
    setOpenAddTemplate,
    edit,
    editTitle,
    data,
    setOpenEditForm,
    specificationGroups,
    setFetch,
    successCallback,
    setTemplate,
    templates,
}){

    const {enqueueSnackbar} = useSnackbar()
    const {orgId} = useContext(UserContext);

    const [loading, setLoading] = useState(false)
    const defaultValues={
        name:'',
        groups:[],
    }
    const { exitFromPlatform } = useExit()
    const fieldMap=[
        {
            name:'name',
            label:'Template name',
            placeholder:'Template name',
            type:'text',
            fieldProps: {
              required: true
            }
        },
        {
            name:'groups',
            label:'Link to group',
            placeholder:'Link to group',
            type:'select',
            fieldProps: {
                multiple:true,
                choicesAPI:"/specs/group/",
                titleKey:'name'
              },
        },
       
    ]


  
      const handelformsubmit = async (e) => {
        setLoading(true)
        if(e?.name === ''){
          enqueueSnackbar('Please enter the template name', {variant:'error'})
          setLoading(false)
          return
        }else{
          const newData = {
            name: e?.name,
            groups: e?.groups?.map((e) =>{
              return e.id
            }) || []
          }
          let service;
          let apiUrl;
          if(data?.id){
            service = apiService.patch
            apiUrl = `specs/template/${data?.id}/`
          }else{
            service = apiService.post
            apiUrl = `specs/template/`
          }
          service(apiUrl, newData).then((res) =>{
            if(data?.id){
              enqueueSnackbar('Template Updated', {variant:'success'})
              let newList = [...templates];
              newList = newList.map((item) =>{
                if(item.id === res.data.id){
                  return res.data
                }else{
                  return item
                }
              })
              setTemplate(newList)
              successCallback()
              onClose()
            }else{
              enqueueSnackbar('Template Added', {variant:'success'})
              const newList = [...templates, res.data];
              setTemplate(newList)
              successCallback()
              onClose()
            }
            setLoading(false)
          }).catch((error) =>{
            setLoading(false)
            if(error.response?.data){
              const returnedError = returnError(error.response?.data)
              if(returnedError === 'Given token not valid for any token type'){
                exitFromPlatform()
            }else{
                enqueueSnackbar(returnedError, {variant:'error'})
            }
          }
          })
        }
    }
   
    return(
        <>
            <FormModal  title={edit? editTitle:title} open={open} onClose={onClose}>
                <Form
                    defaultValues={defaultValues}
                    fieldMap={fieldMap}
                    primaryBtnTitle={data?.name? 'Update':'Add'}
                    formSubmit={handelformsubmit}
                    data={data}
                    loading={loading}
                />
            </FormModal>
        </>
    )
}
export default AddTemplate;